import { render, staticRenderFns } from "./performancechair.vue?vue&type=template&id=6f71aa5e&scoped=true&"
import script from "./performancechair.vue?vue&type=script&lang=js&"
export * from "./performancechair.vue?vue&type=script&lang=js&"
import style0 from "./performancechair.vue?vue&type=style&index=0&id=6f71aa5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f71aa5e",
  null
  
)

export default component.exports